export const getResourceUrl = (url?: string) =>
  url ? (url.startsWith("http") ? url : `/sp/resources/${url}/download`) : "";
